import React, { memo } from 'react';
import { Badge } from './PriceBadge.styles';
import { formatPrice } from '../../utils/util';

// Price bubble in the bottom right corner of a media card. `cost` is already in USD.
const PriceBadge = ({ cost, free = false, className }) => {
  if (free) return <Badge className={className}>FREE</Badge>;
  if (!cost) return null;
  return <Badge className={className}>${formatPrice(cost)}</Badge>;
};

export default memo(PriceBadge);
